import React, { useState } from 'react';
import { Col, Row, Breadcrumb, Table, Spin } from 'antd';
import { Data } from '../data/Data';
import { ReportsCols } from '../data/Columns';
import ReportsForm from '../components/reports/ReportsForm';

function Reports() {
    const [reports, setReports] = useState([]);
    const [formData, setFormData] = useState({ organization: '', region: '', product: '', date: null });
    const [loading, setLoading] = useState(false);

    const handleFinish = () => {
        setLoading(true);
        setTimeout(() => {
            const filtered = Data.filter(
                (item) => {
                    return (
                        (formData.organization ? item.organization.toLowerCase().includes(formData.organization.toLowerCase()) : true) &&
                        (formData.region ? item.region.toLowerCase().includes(formData.region.toLowerCase()) : true) &&
                        (formData.product ? item.product.toLowerCase().includes(formData.product.toLowerCase()) : true) &&
                        (formData.date ? item.date === formData.date : true)
                    );
                }
            );
            setReports(filtered);
            setLoading(false);
        }, 500); // Simulating a delay for demonstration
    };

    
    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                <h1 style={{ color: '#102F10' }}>
                    <Breadcrumb
                        items={[
                            {
                                title: <a href="/">Home</a>,
                            },
                            {
                                title: 'Reports',
                            },
                        ]}
                    />
                </h1>
            </div>

            <Row gutter={[32, 24]}>
                <Col xs={24}>
                    <ReportsForm formname="reports_filter" formData={formData} setFormData={setFormData} onHndleFinish={handleFinish}/>
                </Col>
                <Col xs={24}>
                    <Spin spinning={loading} size="large">
                        <Table columns={ReportsCols} dataSource={reports} rowKey="id" pagination={false} size='middle' scroll={{ x: 800 }} />
                    </Spin>
                </Col>
            </Row>            
        </>
    );
}

export default Reports;
